import React from 'react';
import '../../App.css';

function About() {
  return (
    <div className="About">
        <section id="about-header" className="section">
        <div className="container">
            <div className="section-header">
                <h1 className="section-title">About Us</h1>
                <p className="section-description">
                  Learn more about AAMB, our capabilities, and how we deliver enterprise-grade solutions.
                </p>
            </div>
        </div>

        <section className="company-overview">
        <div className="container">
        <div className="capability-card">
          <h2>Company Overview</h2>
          <p><strong>DUNS / UEI:</strong> F8LMVJRBQFK1</p>
          <p><strong>CAGE Code:</strong> 11FC9</p>
          <p><strong>Business Structure:</strong> Woman-Owned Small Business (WOSB)</p>
          <p><strong style={{marginBottom: '0.5rem'}}>NAICS Codes:</strong></p>
          <ul style={{marginBottom: '0'}}>
            <li>541511 – Custom Computer Programming Services</li>
            <li>541512 – Computer Systems Design Services</li>
            <li>518210 – Data Processing, Hosting, and Related Services</li>
            <li>541519 – Other Computer Related Services</li>
          </ul>
        </div>

        </div>
      </section>

      <section className="contact-information">
        <div className="container">
        <div className="capability-card">
          <h2>Contact Information</h2>
          <p><strong>Email:</strong> <a href="mailto:mgmt@aamb.dev">mgmt@aamb.dev</a></p>
          <p><strong>Phone:</strong> 703-725-5718</p>
          <p><strong>Website:</strong> <a href="https://www.aamb.dev" target="_blank" rel="noopener noreferrer">www.aamb.dev</a></p>
        </div>
        </div>
      </section>

      <section className="core-competencies">
        <div className="container">
        <div className="capability-card">
          <h2>Core Competencies</h2>
          <ul className="clean-bullets">
            <li>Cloud Architecture & Optimization (AWS-certified solutions)</li>
            <li>Custom Software Development</li>
            <li>Infrastructure as Code (IaC) & DevOps Automation</li>
            <li>Serverless Application Design</li>
            <li>Agile Project Management & Consulting</li>
            <li>Legacy System Modernization</li>
            <li>CI/CD Pipeline Implementation</li>
            <li>Cloud Security and Compliance</li>
          </ul>
          </div>
        </div>
      </section>

      <section className="differentiators">
        <div className="container">
        <div className="capability-card">
          <h2>Differentiators</h2>
          <ul className="clean-bullets">
            <li>Deep experience in AWS-native services (Lambda, ECS, S3, etc.)</li>
            <li>Proven track record of delivering scalable, secure cloud solutions</li>
            <li>Flexible, startup-minded team with rapid delivery capabilities</li>
            <li>Transparent communication and client-focused delivery</li>
            <li>Strong documentation and government compliance awareness</li>
          </ul>
          </div>
        </div>
      </section>

      <section className="past-performance">
        <div className="container">
        <div className="capability-card">
          <h2>Past Performance</h2>

          <div className="project">
            <h3>Client: Internal Amazon Teams (while at AWS)</h3>
            <h4>Project: Scalable Serverless Architecture for Internal Finance/Accounting Teams</h4>
            <p><strong>Summary:</strong> Led the design and implementation of a serverless platform using AWS Lambda, Step Functions, and EventBridge to support thousands of internal users with near-zero downtime. The platform reduced infrastructure overhead and improved deployment times across multiple teams.</p>
            <p><strong>Technologies:</strong> AWS Lambda, API Gateway, DynamoDB, Step Functions, EventBridge, S3, CloudFormation, CodePipeline</p>
            <p><strong>Outcome:</strong> Reduced time-to-deploy by 40%, enabled fully automated CI/CD pipelines, and delivered a secure, compliant solution used across multiple orgs within AWS.</p>
          </div>

          <div className="project">
            <h3>Client: Capital One (while at Capital One)</h3>
            <h4>Project: Fraud Detection & Real-Time Transaction Monitoring</h4>
            <p><strong>Summary:</strong> Worked as a software engineer on Capital One’s fraud detection systems, contributing to the development and enhancement of real-time analytics platforms that monitor and flag suspicious financial activity. Designed microservices to handle large-scale transaction data and implemented event-driven processing pipelines for real-time insights.</p>
            <p><strong>Technologies:</strong> Java, Python, Kafka, AWS (Kinesis, Lambda, S3), Kubernetes, Spring Boot</p>
            <p><strong>Outcome:</strong> Improved fraud detection accuracy by integrating ML-based scoring pipelines; reduced system latency and enhanced resilience of transaction processing flows supporting millions of users.</p>
          </div>
          </div>
        </div>
      </section>
      </section>
    </div>
  );
}

export default About;
